export const supportResourcesRoutes = [
  {
    path: '/admin/support-resources',
    name: 'support-resources-management',
    meta: { layout: 'dashboard' },
    component: () => import(/* webpackChunkName: "support-resources" */ './SupportResourcesGridView.vue'),
  },
];
